import { render, staticRenderFns } from "./selectLanguage.vue?vue&type=template&id=07dc71a7&scoped=true&name=selectLanguage&"
import script from "./selectLanguage.vue?vue&type=script&lang=js&"
export * from "./selectLanguage.vue?vue&type=script&lang=js&"
import style0 from "./selectLanguage.vue?vue&type=style&index=0&id=07dc71a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc71a7",
  null
  
)

export default component.exports